<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="modal-api-microdata">
    <div class="modal-header">
      <span class="api-microdata-title">{{ $t('api_micro_title') }}</span>
      <div class="icon-close" @click="modalClose" />
    </div>
    <div v-if="clientId" class="modal-content">
      <span class="subtitle">{{ $t('api_def') }}</span>
      <span>{{ $t('api_micro_def_res') }}</span>
      <span class="subtitle">{{ $t('api_func') }}</span>
      <span>{{ $t('api_micro_func_res') }}</span>
      <span class="subtitle">{{ $t('api_micro_ex') }}</span>
      <span>{{ $t('api_res') }}</span>
      <a :href="parsedUrl">
        <span class="url">{{
          parsedUrl
        }}</span>
      </a>
      <span>{{ $t('api_extra') }}</span>
      <div class="cmd-wrapper">
        <span>{{ 'curl -H "X-IBM-Client-Id: ' + clientId + '" -o file.csv "' + parsedUrl + '"' }}</span>
      </div>
    </div>
    <div v-else-if="logged" class="modal-content">
      <span class="subtitle">{{ $t('client_id_required') }}</span>
      <span class="description">{{ $t('how_to_get_client') }}</span>
      <span class="description">{{ $t('user_zone') }} <a :href="'/' + currentLang + '/perfil/user_dates'">{{ $t('user_dates') }}</a></span>
    </div>
    <div v-else class="modal-content">
      <span class="subtitle">{{ $t('register_required') }}</span>
      <span class="description">{{ $t('how_to_register') }} <a class="link" :href="'/' + currentLang + '/register'">{{ $t('register') }}</a></span>
      <span class="description">{{ $t('if_user') }}</span>
    </div>
    <div class="buttons-wrapper">
      <div class="button-accept" @click="modalClose">
        <span>{{ $t('agree') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { downloadMicrodataCSV } from '@/services/download-api'
import { getUserData } from '@/services/user-api'

/**
 * Renders a modal with a table and title created by props
 * @example [none]
 */
export default {
  name: 'ModalMicrodataApi',
  props: {
    /**
     * Function for close the modal
     */
    modalClose: {
      type: Function,
    },
    /**
     * The name of the opened file
     */
    dataFileInfo: {
      type: Object,
    },
  },
  data () {
    return {
      clientId: false,
      logged: false,
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
    baseLocation() {
      return window.location.origin
    },
    parsedUrl() {
      return this.baseLocation +
        '/services/backend/rest/microdata/export?id=' +
        this.$route.params.cardId +
        '&idResource=' +
        this.dataFileInfo.id +
        '&language=' +
        this.$route.params.lang
    },
    clientID() {
      return window.api_credentials?.clientId
    },
  },
  watch: {
    userData() {
      this.clientId = this.userData.clientId ? this.userData.clientId : false
      this.logged = this.userData.name ? true : false
    },
  },
  methods: {
    downloadFile() {
      //TO DO, WHEN BACKEND HAS NO ERRORS REPLACE DOWNLOAD CALL
      downloadMicrodataCSV(this.$route.params.cardId, this.fileId, this.$route.params.lang)
    },
  },
  asyncComputed: {
    userData() {
      return getUserData().then(resp => {
        return resp
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.modal-api-microdata
  display: flex
  flex-direction: column
  height: 100%
  justify-content: space-between
  width: 100%
  z-index: 10

  h3
    m-font-size(32, 45)
    font-weight: 600
    margin-block-end: 0
    margin-block-start: 0
    margin-left: vw(20px)

  .buttons-wrapper
    display: flex
    margin-bottom: vw(30px)
    margin-left: vw(20px)

    .button-accept
      background-color: black
      border: 1px solid black
      border-radius: 4px
      color: white
      cursor: pointer
      display: flex
      padding: vw(8px) vw(15px)

      &:hover
        background-color: $grey-dark

      span
        m-font-size(14, 20)

  .api-microdata-title
    m-font-size(26, 34)
    font-weight: 600
    margin-block-end: vw(20px)
    margin-block-start: vw(20px)

  .modal-content
    m-font-size(18, 20)
    display: flex
    flex-direction: column
    gap: vw(10px)
    height: "calc(100% - %s)" % vw(160px)
    margin-bottom: vw(20px)
    overflow-y: scroll
    padding: vw(5px) vw(30px)

    .url
      m-font-size(20, 24)
      color: $corporate_color
      cursor: pointer
      margin-top: vw(8px)
      overflow-wrap: break-word
      word-break: break-word

      &:hover
        text-decoration: underline

    .subtitle
      font-weight: 600
      margin-top: vw(15px)
      m-font-size(20, 24)
      
    .description
      margin-top: vw(15px)
      
      a
        color: $corporate_color
        
        &:hover
          text-decoration: underline

    .cmd-wrapper
      background-color: $bcn-light-grey
      border: 1px solid $bcn-grey-y
      border-radius: 4px
      margin: vw(5px) 0
      padding: vw(5px) vw(15px)
      width: 100%

      span
        font-family: monospace
        font-size(14, 20)
        overflow-wrap: break-word
        word-break: break-word

  .modal-header
    align-items: center
    display: flex
    height: vw(80px)
    padding-left: vw(25px)
    position: relative
    width: 100%

    .icon-close
      m-icon("modal-close", 32, $grey-dark)
      cursor: pointer
      position: absolute
      right: vw(20px)
      top: vw(20px)
</style>
